import { Omit } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form'
import { StatusRegulacaoEnum } from 'graphql/types.generated'
import React from 'react'

import { RegulacaoEnumTextMap } from '../model-regulacao'

export interface StatusRegulacaoSelectFieldProps
  extends Omit<SelectFieldProps<StatusRegulacaoEnum>, 'items' | 'itemToString'> {}

export function StatusRegulacaoSelectField(props: StatusRegulacaoSelectFieldProps) {
  const { ...rest } = props

  return (
    <SelectField<StatusRegulacaoEnum>
      items={[StatusRegulacaoEnum.AGUARDANDO_ENVIO]}
      itemToString={itemToString}
      multiple
      {...rest}
    />
  )
}

const itemToString = (item: StatusRegulacaoEnum): string => item && RegulacaoEnumTextMap[item]
